import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_RECEIVABLES_FAILURE,
  FETCH_RECEIVABLES_REQUEST,
  FETCH_RECEIVABLES_SUCCESS
} from "../types";

const fetchReceivables = id => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(FETCH_RECEIVABLES_REQUEST)());
    const response = await api.factoring.getReceivables(id);
    const data = normalize(response, schema.receivable);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_RECEIVABLES_SUCCESS)({
        [id]: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_RECEIVABLES_FAILURE)(err));
  }
};

export default fetchReceivables;
